import { render } from 'preact';
import Store from '@store';
import App from '@components/app';
import './styles/index.css';

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  window.gtag('js', new Date());
  window.gtag('config', process.env.GTAG_PROPERTY_ID, {
    client_storage: 'none',
  });
}

function Root() {
  return (
    <Store>
      <App />
    </Store>
  );
}

if (typeof document !== 'undefined') {
  render(<Root />, document.getElementById('app'));
}

export default Root;
